/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Box, Button, Stack, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import {
  formatHeroLenteResumo,
  formatMedicaoPeriodLabel,
  getPrimeiroNome,
} from './constants';

const HeroStrip = ({
  authData,
  inicio,
  fim,
  lentes,
  heroResumos,
  loading,
  onExport,
  title,
  subtitle,
  diasUteis,
  diasUteisRestantes,
}) => {
  const primeiroNome = getPrimeiroNome(authData?.nome);
  const periodoLabel = formatMedicaoPeriodLabel(inicio, fim);
  const heading = title || 'Minha digitação';
  const periodoEncerrado = fim != null
    && moment(fim).startOf('day').isBefore(moment().startOf('day'), 'day');

  const resumoLines = (lentes || [])
    .map((lente) => {
      const resumo = heroResumos?.[lente.id];
      const texto = formatHeroLenteResumo(resumo, lente);
      if (!texto) return null;
      return `${lente.label} ${texto}`;
    })
    .filter(Boolean);

  const periodoParts = [];
  if (periodoLabel) periodoParts.push(`Período de medição ${periodoLabel}`);
  if (diasUteis != null) {
    periodoParts.push(`ciclo de ${diasUteis} dias úteis`);
  }
  const periodoText = loading && !resumoLines.length && diasUteis == null
    ? `Período de medição ${periodoLabel} · carregando…`
    : [
      periodoParts.join(' · '),
      ...resumoLines,
    ].filter(Boolean).join(' · ');

  const restantesText = periodoEncerrado
    ? 'Período encerrado'
    : diasUteisRestantes == null
      ? null
      : diasUteisRestantes === 1
        ? 'Falta 1 dia útil para o fim do período'
        : `Faltam ${diasUteisRestantes} dias úteis para o fim do período`;

  return (
    <Stack spacing={1.5} sx={{ pr: 2 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        spacing={1}
      >
        <Box>
          <Typography variant="h4">{heading}</Typography>
          {subtitle ? (
            <Typography variant="body1" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          ) : (
            primeiroNome && (
              <Typography variant="body1" sx={{ mt: 0.5 }}>
                Olá, {primeiroNome}
              </Typography>
            )
          )}
        </Box>
        {onExport && (
          <Button
            variant="contained"
            startIcon={<DescriptionOutlinedIcon />}
            onClick={onExport}
          >
            Exportar
          </Button>
        )}
      </Stack>

      {periodoLabel && (
        <Box>
          <Typography variant="body2" color="text.secondary">
            {periodoText}
          </Typography>
          {restantesText && (
            <Typography variant="body2" color="text.secondary">
              {restantesText}
            </Typography>
          )}
        </Box>
      )}
    </Stack>
  );
};

HeroStrip.propTypes = {
  authData: PropTypes.object.isRequired,
  inicio: PropTypes.number,
  fim: PropTypes.number,
  lentes: PropTypes.arrayOf(PropTypes.object),
  heroResumos: PropTypes.object,
  loading: PropTypes.bool,
  onExport: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  diasUteis: PropTypes.number,
  diasUteisRestantes: PropTypes.number,
};

HeroStrip.defaultProps = {
  inicio: null,
  fim: null,
  lentes: [],
  heroResumos: {},
  loading: false,
  onExport: undefined,
  title: undefined,
  subtitle: undefined,
  diasUteis: null,
  diasUteisRestantes: null,
};

export default HeroStrip;
